import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { stockService } from "../../../services/stock.service";
import { IOption } from "Dashboard/domain/IOption";

const RepositorySelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      try {
        const repositories = await stockService.getRepositoriesForStock(
          "Lager"
        );
        const op = repositories.map((repository) => {
          return {
            label: repository.name,
            value: repository.repositoryId,
          };
        });
        setOptions(op);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else {
      setValue(undefined);
    }
  }, [options, props.value]);

  return (
    <Select
      isClearable
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default RepositorySelect;
